import Header from "../layout/header/Header";
import Footer from "../layout/footer/Footer";

const About = () => {
    const teamInfo = [
        {
            name: 'NUBILA MBETIGI JAMES',
            pic: "https://www.shutterstock.com/image-photo/smiling-cheerful-young-adult-african-600nw-1850821510.jpg",
            designation: "Group Coordinator and Front-End Developer",
        },
        {
            name: 'Pradeep Reddy Kommula',
            pic: "https://media.istockphoto.com/id/1196391445/photo/portrait-of-a-happy-young-man-of-asian-ethnic-descent.jpg?s=612x612&w=0&k=20&c=FTBzIOLoMfuenRMcQKkvpkiDg7nD8ZHmjhtYSZvskfE=",
            designation: "Front-End Developer",
        },
        {
            name: 'DHALIWAL AMRITPAL SINGH',
            pic: "https://img.freepik.com/free-photo/stylish-handsome-indian-man-tshirt-pastel-wall_496169-1571.jpg",
            designation: "Back-End Developer",
        },
        {
            name: "MAYANK MODI",
            pic: "https://t4.ftcdn.net/jpg/02/41/80/03/360_F_241800383_iDZI5KL0G44EiMEcgQXToVFRA0GGoS3M.jpg",
            designation: "Back-End Developer and Project Manager",
        }
        
    ]
  return (
    <>
      <Header />
      <div className="container mx-auto my-20">
        <h1 className="font-semibold text-center text-4xl">About Us</h1>
        <div className="w-20 bg-red-600 h-1 rounded mx-auto"></div>
        <p className="text-center text-gray-800/90 mt-3">
          The Team Behind MAK Electronic
        </p>
        <p className="text-center text-gray-800/90 mt-3">
          We are here to make a difference in your life. Come on-board and begin
          win TODAY.
        </p>

        <div className="grid grid-cols-4 gap-5 my-10">

          {/* member 1 */}
          {teamInfo.map((item, index) => (
          <div className="space-y-2" key={index}>
            <img
              src={item?.pic}
              className="rounded h-[200px] mx-auto"
              alt="pic"
            />
            <div>
            <h3 className="text-center text-primary font-semibold">{item?.name}</h3>
              <p className="text-center text-sm">{item?.designation}</p>
            </div>
            <div className="text-gray-800 text-sm">
              <p>
                {item?.name} is one of the co-founder of MAK Electronics and works to
                coordinate the activities of the Group.
              </p>
              <ul className="team-icon">
                <li>
                  <a href="#" className="twitter">
                    <i className="fab fa-twitter"></i>
                  </a>
                </li>

                <li>
                  <a href="#" className="facebok">
                    <i className="fab fa-facebook"></i>
                  </a>
                </li>

                <li>
                  <a href="#" className="gmail">
                    <i className="far fa-envelope"></i>
                  </a>
                </li>
              </ul>
            </div>
          </div>
          ))}
        </div>
      </div>
      <Footer />
    </>
  );
};

export default About;
